import DepsService from 'services/dependencies';

const CONTEXT = 'subordinateList';

const fetchSubordinateList = async ({ retailerId, ...queryParams }) => {
  const { url } = DepsService.rest.inventory.subordinates.list;
  const urlParams = { retailerId };

  const { content, ...pagination } = await DepsService.restSrv.get(CONTEXT, url, queryParams, urlParams);

  return {
    content,
    ...pagination,
  };
};

export default {
  fetchSubordinateList,
};



// WEBPACK FOOTER //
// ./src/modules/utils/rw-subordinates/resources/subordinate-list.api.js